import React from 'react';
import { motion } from 'framer-motion';
import { Quote, AlertCircle, Sparkles } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function StorySections() {
  return <div className="py-16 md:py-24 space-y-24" data-id="element-92">
      {/* SECTION 1: EL GANCHO */}
      <section className="px-4" data-id="element-93">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="max-w-4xl mx-auto bg-white rounded-3xl p-8 md:p-12 shadow-soft relative" data-id="element-94">
          <Quote className="absolute top-6 left-6 w-12 h-12 text-gold/20 rotate-180" data-id="element-95" />
          <div className="relative z-10" data-id="element-96">
            <p className="text-xl md:text-2xl font-serif text-chocolate leading-relaxed mb-6" data-id="element-97">
              ¿Sientes que el dinero no alcanza o te duele tener que pedir
              permiso para cada gasto del hogar?
            </p>
            <p className="text-lg text-chocolate-light leading-relaxed mb-6" data-id="element-98">
              La mayoría de las mujeres creen que para vender postres necesitan
              una cocina industrial o miles de seguidores en Instagram.
            </p>
            <p className="text-lg text-chocolate font-medium leading-relaxed bg-gold/10 p-6 rounded-xl border-l-4 border-gold" data-id="element-99">
              La realidad es que solo necesitas 3 cosas: un postre que se vea
              irresistible, un proceso que no te quite todo el día y el plan
              exacto para que tus vecinos y seguidores te supliquen comprarte.
            </p>
          </div>
        </motion.div>
      </section>

      {/* SECTION 2: AGITACIÓN DEL DOLOR */}
      <section className="px-4 bg-chocolate text-cream py-20" data-id="element-100">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="max-w-3xl mx-auto text-center" data-id="element-101">
          <AlertCircle className="w-16 h-16 text-rose-400 mx-auto mb-8" data-id="element-102" />
          <h2 className="font-serif text-3xl md:text-4xl font-bold mb-8 text-cream" data-id="element-103">
            Hacer pasteles por hobby es hermoso,{' '}
            <span className="text-rose-400 italic" data-id="element-104">
              hasta que intentas venderlos.
            </span>
          </h2>
          <div className="space-y-6 text-lg md:text-xl text-cream-dark/90 leading-relaxed text-left md:text-center" data-id="element-105">
            <p data-id="element-106">
              Te pasas horas horneando para que te digan{' '}
              <span className="font-bold text-white" data-id="element-107">"está muy caro"</span>.
            </p>
            <p data-id="element-108">
              Gastas en ingredientes caros y al final del mes no ves ganancia
              real. Te sientes estancada, cansada y con la cocina hecha un
              desastre, sin saber si mañana entrará un solo pedido por
              Instagram.
            </p>
            <p className="font-serif text-2xl text-gold-light pt-6 border-t border-cream/10 mt-8" data-id="element-109">
              ¿Ese es realmente el negocio que soñaste?
            </p>
          </div>
        </motion.div>
      </section>

      {/* SECTION 3: LA REVELACIÓN */}
      <section className="px-4" data-id="element-110">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={fadeIn} className="max-w-4xl mx-auto" data-id="element-111">
          <div className="flex justify-center mb-8" data-id="element-112">
            <Sparkles className="w-12 h-12 text-gold" data-id="element-113" />
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-center text-chocolate mb-10" data-id="element-114">
            El secreto no está en tener 100 recetas.
          </h2>
          <div className="bg-cream-dark rounded-3xl p-8 md:p-12 border border-gold/20" data-id="element-115">
            <p className="text-xl md:text-2xl text-chocolate text-center leading-relaxed mb-8" data-id="element-116">
              El secreto está en tener{' '}
              <span className="font-bold text-rose-600 bg-rose-50 px-2 py-1 rounded" data-id="element-117">
                Postres Ancla
              </span>
              .
            </p>
            <p className="text-lg text-chocolate-light leading-relaxed mb-6 text-center" data-id="element-118">
              Postres como la Tarta Ópera o la Milhojas que justifican un precio
              premium, combinados con Postres en Vasito que se producen en masa.
            </p>
            <p className="text-lg font-medium text-chocolate text-center" data-id="element-119">
              He unido mis 8 guías maestras para cubrir cada hueco: desde la
              mentalidad y la técnica profesional, hasta el marketing digital
              que pone tu negocio en el mapa.
            </p>
          </div>
        </motion.div>
      </section>
    </div>;
}